import { render, staticRenderFns } from "./ImportGoodsModal.vue?vue&type=template&id=6e8c75c8&scoped=true&"
import script from "./ImportGoodsModal.vue?vue&type=script&lang=ts&"
export * from "./ImportGoodsModal.vue?vue&type=script&lang=ts&"
import style0 from "./ImportGoodsModal.vue?vue&type=style&index=0&id=6e8c75c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e8c75c8",
  null
  
)

export default component.exports